import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, FormLabel} from 'carbon-components-react';
import { useFormContext } from 'react-hook-form';
import FormCheckbox from './form_elements/form-checkbox';
import { useNavigate } from 'react-router';
import {Edit16 } from '@carbon/icons-react';
import { buildDependents, getQualifiedDependents, hasQualifiedDependents, isMarried } from './contact-builder';
import { isCourtOrdered } from './is-court-ordered';
import { WarningHexFilled20 } from '@carbon/icons-react';
import { PlanType } from './enums/plan-type';

const DependentsSelector = ({plan, planOption,reset,onDisabled}) => {
    const enrollments = useSelector(s => s.enrollments);
    const {setValue, formState, trigger} = useFormContext();
    const [dependents, setDependents] = useState([]);
    const navigate = useNavigate();
    const [married, setMarried] = useState();

    const showDependent = (optionName, relationship) => {
        if(optionName === "Family"){
            return true;
        }        
        if(optionName === "Employee + Dependents"){
            return true;
        }

        if(optionName.indexOf("Child") !== -1 && relationship.toLowerCase().indexOf("child") !== -1){
            return true;
        }

        if(optionName.indexOf("Spouse") !== -1 && (relationship.toLowerCase() === "spouse" || relationship.toLowerCase() === "domestic partner")){
            return true;
        }

        return false;
    }
    useEffect(() => {
        if(Array.isArray(enrollments) || !planOption)
            return;
        const married = isMarried(enrollments);
        setMarried(married);
        let deps =[];
        const enrollment = enrollments.selections?.find(s => s.planId === plan.id);
        var qualifiedDependents = []
        if(plan?.planType === PlanType.BasicLife){
            if(hasQualifiedDependents(enrollments)){
                qualifiedDependents = getQualifiedDependents(enrollments);
                qualifiedDependents.forEach((dependent) => {
                    let d = {...dependent};
                    d.enrolled = true;
                    d.disabled = true;
                    deps.push(d);
                });

            }
        }else{
            if(enrollments?.dependents){
                qualifiedDependents = buildDependents(enrollments);
                qualifiedDependents.forEach((dependent) => {
                    if(showDependent(planOption.name, dependent.relationship.name)) {
                        let d = {...dependent};
                        if(enrollment && enrollment.planOption === planOption.id)
                            d.enrolled = enrollment.dependents?.some(s => s === dependent.id)
                        else
                            d.enrolled = true;
    
                        if(planOption.planType === PlanType.BasicLife){
                            d.enrolled = true;
                        }
                        d.disabled = isCourtOrdered(d.courtOrdered, plan.planType);
                        deps.push(d);
                    }
                });
            }
        }
            
        setDependents(deps);

        setValue("dependents", deps);
    }, [plan, enrollments, planOption, reset]);

    const onSelection = () => {
        trigger("dependents");
    }

    
    
    return ( 
        <>
        {onDisabled(plan,planOption,dependents)}

        {dependents && dependents.length > 0 ?
            <div>
                <FormLabel>
                    Dependents <Link kind="ghost" size="sm" role="button" renderIcon={Edit16} onClick={() => navigate("/Dependents")}></Link>
                 </FormLabel>
                {dependents.map((d, i) => 
                    <div key={d.id} className="flex">
                        <span>
                            <FormCheckbox 
                                name={`dependents[${i}].enrolled`} 
                                id={`dependents[${i}].id`} 
                                className="inline-flex" 
                                label='' 
                                onChange={onSelection} checked={d.enrolled} 
                                props={{hideLabel : true}} 
                                disabled={d.disabled}
                             />
                        </span>
                        <span className='pt-2 pl-2'>
                            {d.firstName} {d.lastName} ({d.relationship.name}) 
                        </span>
                    </div>
                )}
                <div>
                {!!formState.errors["dependents"] ? <div className='text-danger my-2'>{formState.errors["dependents"]?.message}</div> :<></>}
                </div>
            </div>
        :
        (planOption && planOption.id !== "1") ? <div className='mt-4 text-lg'>
                          <WarningHexFilled20 aria-label="alert" className="inline-block mb-1 mr-1 text-red-600" />
                          {plan?.planType === PlanType.BasicLife && married ?
                <>
                  You must add your spouse or domestic partner as a dependent in order to enroll in this plan. If you do not have a spouse or domestic partner, you must change your marital status to single.
                </> :
                <>Additional dependents need to be added for you to qualify for this plan.</>
              }

                             
                            
                          &nbsp;<Link kind="ghost" size="sm" role="button" onClick={() => navigate("/Dependents")}>Add Dependent(s)</Link> </div> : <></>
}
        </>
     );
}
 
export default DependentsSelector;